var path = '/app/pages/imaginacao/imaginacao.html';
var html = "<div class=\"container-fluid fill\"> <div class=hud-stages> <div class=\"col-8 status-bar\"> <div class=\"status-bar-color blue-bar\"> <ul class=bar ng-class=\"{ 'full': $ctrl.level === 3, 'half': $ctrl.level === 2, 'empty': $ctrl.level === 1 } \"> <li></li> <li></li> <li></li> </ul> </div> </div> <div class=\"col-2 hud-buttons status-bar\"> <a ui-sref=main class=btn-back></a> <div class=btn-sound></div> <div class=btn-help ng-click=$ctrl.Dialog.showHelp(0)></div> </div> </div> <div class=stage> <draw-game level=$ctrl.level end-game=$ctrl.endGame()></draw-game> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/imaginacao/imaginacao.html
// module id = 281
// module chunks = 0